<template>
    <icon-button :icon="icon" :size="size" :title="title" @click="doLogout" :tabindex="tabindex"></icon-button>
</template>

<script>
import axios from 'axios';
import IconButton from './iconButton';

export default {
  name: 'logout',
  components: { IconButton },
  props: {
    icon: {
      type: String,
      default: 'sign-out-alt'
    },
    size: String,
    title: String,
    tabindex: {
      type: [ Number, String ],
      default: 0
    }
  },
  methods: {
    doLogout() {
      const opt = {
        okText: this.$t('general:text.yes'),
        cancelText: this.$t('general:text.no'),
        animation: 'zoom'
      };
      this.$dialog.confirm(this.$t('logout.confirm'), opt).then(() => {
        let x = localStorage.getItem('token');
        let svr = localStorage.getItem('server');
        axios.get(`${svr}/rest/logout?auth=${x}`).then(() => {
          this.$store.dispatch('logout', () => {
            this.$router.push('/login');
          });
        });
      });
    }
  }
};
</script>

<style scoped>

</style>
